// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { toggleModal } from '../../storage/actions/modalsActions';
import Content from '../../components/clientPaymentMethods/Content';
import Loader from '../../components/dashboard/common/Loader';
// eslint-disable-next-line import/no-cycle
import Notification from '../../components/notification';
import {
  PROVIDER_ELAVON,
  mergePaymentMethodsForList,
} from '../../utils/elavonPayments';
import { useFoundingSourceContext } from "../admin/FundingSources";
import {deleteFundingSource, makePrimaryFundingSource} from "../../storage/actions/superAdmin";
import DashboardIcon from '../../components/dashboard/icons/DashboardIcon';

const ClientPaymentMethods = ({
  auth, toggleModal, mainContainer, isReload,  deleteFundingSource, makePrimaryFundingSource
}) => {
  const foundingSourceContext = useFoundingSourceContext({
    isReload,
    toggleModal,
    deleteFundingSource,
    makePrimaryFundingSource
  });
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const getPaymentMethods = () => {
    setIsLoaded(false);
    axios.get('/api/payment/payment-methods', { params: { email: auth.user.email } })
      .then((res) => {
        setPaymentMethods(mergePaymentMethodsForList(res));
        setIsLoaded(true);
      });
  };

  const editPaymentMethod = paymentMethod => {
    toggleModal(true, 'addOrEditPaymentMethod', false, paymentMethod);
  };

  const deletePaymentMethod = async (paymentMethod) => {
    const id = paymentMethod._id || paymentMethod.id;
    const params = new URLSearchParams({ id });
    if (paymentMethod.provider === PROVIDER_ELAVON) {
      params.set('provider', PROVIDER_ELAVON);
      if (paymentMethod.hostedCardId) {
        params.set('hostedCardId', paymentMethod.hostedCardId);
      }
    } else {
      params.set('paymentMethodId', paymentMethod.id);
    }
    const { data: { message } } = await axios.delete(`/api/payment/payment-methods/?${params.toString()}`);
    if (message) {
      Notification('success', { message });
      getPaymentMethods();
    }
  };

  const makePrimary = paymentMethod => {
  };

  useEffect(() => {
    getPaymentMethods();
  }, [isReload]);

  return (
    <div className="subpage-wrap">
      <div className="subpage-header">
        <h1 className="subpage-title">Payment Method</h1>
        <button
          className="subpage-btn subpage-btn--mint"
          type="button"
          aria-label="add payment method"
          onClick={() => toggleModal(true, 'addOrEditPaymentMethod')}
        >
          <DashboardIcon name="payment" size={18} strokeWidth="2.5" />
          Add Payment Method
        </button>
      </div>

      {isLoaded ? (
        <Content
          paymentMethods={paymentMethods}
          editPaymentMethod={editPaymentMethod}
          deletePaymentMethod={deletePaymentMethod}
          makePrimary={makePrimary}
          auth={auth}
        />
      ) : (
        <Loader />
      )}
    </div>
  );
};

const mapDispatchToProps = {
  toggleModal,
  deleteFundingSource,
  makePrimaryFundingSource,
};

const mapStateToProps = state => ({
  auth: state.auth,
  isReload: state.applicationState.isReload,
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientPaymentMethods);
